import { LocalVariable } from '../types/variable';

export const VARIABLE_REGEX = /^{{(.*?)}}$/;

export function isVariable(value: string): boolean {
  return !!getVariablesFromText(value).length;
}

export function getVariablesFromText(input: string): string[] {
  const regex = new RegExp(VARIABLE_REGEX, 'g');
  const matches = [];
  let match;

  while ((match = regex.exec(input)) !== null) {
    matches.push(match[1]);
  }

  return matches;
}

export const getRelevantVariables = (
  variables: LocalVariable[],
  formats: string[],
  variableType?: string,
) => {
  // If type is defined, filter by type. Then filter out units.
  return variables
    .filter((v) => (variableType ? v.type === variableType : true))
    .filter((v) => (formats.length ? formats.includes(v.unit || '') : true));
};

export const getVariableIcon = (type: string) => {
  return type === 'color'
    ? 'variable.color'
    : type === 'number'
      ? 'hashtag'
      : type === 'text'
        ? 'text'
        : type === 'font'
          ? 'text.font'
          : type === 'image'
            ? 'image'
            : 'hashtag';
};

export const getVariableValue = (
  variable: string,
  variables: { key: string; value?: string }[],
) => {
  return variables.find((v) => variable.includes(v.key))?.value;
};

export const getVariableUnit = (variable: string, variables: { key: string; unit?: string }[]) => {
  return variables.find((v) => variable.includes(v.key))?.unit;
};

export const getVariableDisplayText = (variableType: string, variable?: LocalVariable) => {
  // For number variables, show the value and unit
  if (variableType === 'number') {
    return `${variable?.value || '0'}${variable?.unit || ''}`;
  }

  // For everything else, show the variable name
  return variable?.name || '0';
};
